module.exports = {"TXTWCL_Self_excluded_Historical_Bets":{"id":"TXTWCL_Self_excluded_Historical_Bets","defaultMessage":"Auto-exclu - Historique des paris"}}